import React, { memo, useEffect } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { FormControl, Select, MenuItem, Typography, CircularProgress } from '@mui/material';
import StyledTableCell from 'components/Table/StyledTableCell';
import utils from 'components/utils';
import head from 'lodash.head';

const DepotComp = ({ ean, depot, type, depots, epipoli }) => {
	const availableDepots = utils.useFilteredDepots();
	const wishlists = useStoreState(state => state.wishlist.listLight.items);
	const loadingItemsForDepots = useStoreState(state => state.wishlist.details.loading);
	const selectDepot = useStoreActions(dispatch => dispatch.selection.selectDepot);
	//const specialDepots = useStoreState(state => state.wishlist.details.specialDepots);
	//const selectedDepots = useStoreState(state => state.selection.items);
	const enableDepots = depots.filter(d => (type === 200 ? d.id === 'FS01' : d.enable)).map(dep => dep.id);
	//Elimino i depositi non abilitati tra quelli disponibili per l'utente (ordinati per coincidere col deposito per tutti)
	/* -> Il controllo è spostato sul pulsante
 	const depotsForSelect = availableDepots
		.filter(dep => (specialDepots.length == 0 ? enableDepots.includes(dep.id) : specialDepots.includes(dep.id)))
		.sort((a, b) => (a.id < b.id ? -1 : a.id > b.id ? 1 : 0));
	*/
	const depotsForSelect = availableDepots
		.filter(dep => enableDepots.includes(dep.id))
		.sort((a, b) => (a.id < b.id ? -1 : a.id > b.id ? 1 : 0));
	//Imposto il valore da selezionare se contenuto tra i depositi validi
	const selvalDep = depotsForSelect.filter(dep => dep.id === depot.id).map(d => d.id);
	const selval = selvalDep.length > 0 ? selvalDep[0] : depotsForSelect.length > 0 ? head(depotsForSelect).id : '';

	/*	
	useEffect(() => {
		//Se la WL è speciale e ha già dei titoli seleziono il deposito valido
		if (specialDepots.length > 0) selectDepot({ ean, depot: specialDepots[0] });
		//Se la WL non è speciale seleziono il primo deposito disponibile in modo che coincida con quello valido per tutti
		else selectDepot({ ean, depot: depotsForSelect[0].id });
	}, [specialDepots]);
*/
	return (
		<StyledTableCell style={{ minWidth: 100, maxWidth: 100, width: 100 }}>
			{/*loadingItemsForDepots && <CircularProgress style={{ alignSelf: 'center' }} size={16} /> */}
			{type !== 100 && type !== 200 && (
				<FormControl variant="outlined" style={{ maxWidth: 100 }}>
					<Select
						value={selval}
						onChange={e => {
							console.log('seleziono', e.target.value);
							selectDepot({ ean, depot: e.target.value });
						}}
						style={{ height: 35 }}
					>
						{depotsForSelect.map(ad => (
							<MenuItem key={ad.id} value={ad.id}>
								{ad.description}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			)}
			{(type === 100 || type == 200) && <Typography variant="body2">Fast Hub</Typography>}
		</StyledTableCell>
	);
};

const Depot = memo(
	({ item, epipoli }) => (
		<DepotComp
			ean={item.ean}
			depot={item.selection.depot}
			type={item.type}
			depots={item.depots}
			epipoli={epipoli}
		/>
	),
	(p, n) =>
		p.item.ean === n.item.ean &&
		p.item.selection.depot === n.item.selection.depot &&
		p.item.type === n.item.type &&
		p.item.dep === n.item.depots
);

export default Depot;
